
<template>
  <div
    class="flex items-center justify-center w-full h-screen bg-img vx-row no-gutter"
    id="page-login"
  >
    <div class="m-0 vx-col">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="items-center justify-center vx-row no-gutter">
            <div class="vx-col d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="mb-10 vx-card__title">
                  <img
                    src="@/assets/images/logo/logo.png"
                    class="mx-auto"
                    style="max-width: 45vh"
                  />
                </div>

                <div>
                  <ValidationObserver v-slot="{ invalid }">
                    <ValidationProvider
                      immediate
                      name="full name"
                      rules="required|alpha_spaces|min:3|max:100"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        name="fullName"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        label-placeholder="Full Name"
                        v-model="fullName"
                        class="w-full"
                        :success="errors.length === 0"
                        success-text="Full Name is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <ValidationProvider
                      immediate
                      name="email address"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-mail"
                        icon-pack="feather"
                        label-placeholder="Email address"
                        v-model="email"
                        class="w-full"
                        :success="errors.length === 0"
                        success-text="Email address is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <ValidationProvider
                      immediate
                      name="password"
                      rules="required|min:6|max:30"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="password"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="Password"
                        v-model="password"
                        class="w-full mt-6"
                        :success="errors.length === 0"
                        success-text="Password is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <vs-alert
                      :active="isError"
                      class="mt-2"
                      color="danger"
                      icon="new_releases"
                    >
                      <span>{{ error_message }}</span>
                    </vs-alert>
                    <VueRecaptcha
                      :sitekey="site_key"
                      ref="invisibleRecaptcha"
                      @verify="register"
                      size="invisible"
                      :loadRecaptchaScript="true"
                    >
                    </VueRecaptcha>
                    <router-link :to="{ name: 'login' }">
                      <vs-button type="border" class="mt-8">Back</vs-button>
                    </router-link>
                    <vs-button
                      class="float-right mt-8 bg-primary"
                      :disabled="invalid"
                      @click="$refs.invisibleRecaptcha.execute()"
                      >Register</vs-button
                    >
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      fullName: "",
      email: "",
      password: "",
      isError: false,
      error_message: "",
      checkbox_remember_me: false,
      site_key: process.env.VUE_APP_CAPTCHA_PUBLIC,
    };
  },
  methods: {
    async register(token) {
      this.$http
        .post("/auth/register", {
          fullName: this.fullName,
          email: this.email,
          password: this.password,
          "g-recaptcha-response": token,
        })
        .then((res) => {
          if (res.data && res.data.status === true) {
            this.$router.push("/login");
            this.$swal({
              position: "bottom-end",
              icon: "success",
              toast: true,
              title:
                "Your account successfully created, please login to continue",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          this.isError = true;
          this.error_message = err.response.data.message;
        });
    },
  },
  created() {
    clearInterval(localStorage.notifier);
  },
};
</script>
